module.exports = __webpack_public_path__ + "static/media/BaskervilleItalicBT.bfffe626.ttf";